import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CallToWaitingAreaRequestModel } from '../../models/allocation-call-to-waiting-area';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToWaitingAreaActionService {
  constructor(private http: WrapperHttpService) {}

  callToWaitingArea(body: CallToWaitingAreaRequestModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.CallToWaitingArea}`;

    return this.http.withLoading().post<void>(url, body);
  }
}
